import React from "react";

import { Main, Bold } from "../styles";

export default function Answer() {
  return (
    <Main>
      <Bold as="h1" style={{ fontSize: 22 }} color="#4B4B4B">
        Documentação e apresentação do condutor
      </Bold>
      <Bold className="mt-3" color="#000FFF">
        Documentação do Condutor
      </Bold>
      <p>
        A - CETPP: Curso de Especialização no Transporte de Produtos Perigosos.
        <ul>
          <li>
            CNH expedida no estado de SP: obrigatório constar no campo
            Observações (validade é a mesmo da CNH). Não aceitar certificado;
          </li>
          <li>
            CNH expedida no estado do RS: quando constar no campo Observações da
            CNH, a validade do CETPP não é a mesma da CNH. O certificado é
            aceito, desde que atenda a Portaria 26/2005 do DENATRAN.
          </li>
          <li>
            CNH expedida nos demais estados: pode constar ou não no campo
            observações da CNH. O certificado é aceito, desde que atenda a
            Portaria 26/2005 do DENATRAN.
          </li>
        </ul>
        <p>
          B - CNH: Carteira Nacional de Habilitação válida e categoria
          compatível com o veículo.
        </p>
      </p>

      <Bold className="mt-1" color="#000FFF">
        Apresentação do Condutor
      </Bold>
      <p>
        A - Traje mínimo obrigatório (calça comprida, camisa ou camiseta com
        mangas curtas ou compridas e calçado fechado).
      </p>
      <p>
        B - Condições físicas aparentes (isento de sinais de uso de drogas e
        álcool, e incapacidade física e mental temporária).
      </p>
    </Main>
  );
}
